import React from 'react';
import custom from './CloseButton.scss';
import IconClose from '../icon-close/IconClose';

const CloseButton = ({ closeButtonLabel, onClick, ...props }) => (
  <button
    className={custom.AlertBanner__closeIcon}
    type="button"
    aria-label={closeButtonLabel}
    onClick={onClick}
    {...props}
  >
    <IconClose />
  </button>
);

export default CloseButton;
